import { appStyles, breakpoints } from '@/constants';

export default function alignWithAppWidth(
  elem,
  { side = 'right', margin = true } = {}
) {
  const right = `calc(${Math.max(
    0,
    (window.innerWidth - breakpoints.desktopLarge) / 2
  )}px + ${appStyles.spacing}`;

  elem.style[side] = right;

  if (margin) {
    elem.style.margin = `0 ${appStyles.spacing}`;
  }
}
